/* DAILE v2 (dv) — announcement strip (sections/dv-announcement.liquid).
 *
 * Module "dv-announcement":
 *   - publishes the strip's real height as --announcement-bar-height on :root
 *     (Prestige and daile-collection-hero subtract it from first-screen
 *     heights); removed again when the section unloads in the theme editor;
 *   - theme editor: on phones only the first message is visible, so a
 *     selected block temporarily takes its place.
 */
(() => {
  'use strict';

  if (!window.DV || typeof window.DV.register !== 'function') return;

  const DV = window.DV;
  const html = document.documentElement;

  DV.register('dv-announcement', (root) => {
    const bar = DV.queryAll(root, '[data-dv-announcement]')[0];
    if (!bar) return undefined;

    const publish = () => {
      const height = bar.getBoundingClientRect().height;
      if (height > 0) html.style.setProperty('--announcement-bar-height', `${height.toFixed(2)}px`);
    };

    let observer = null;
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(publish);
      observer.observe(bar);
    }
    publish();

    const clearSelection = () => {
      bar.classList.remove('dv-announcement--editing');
      bar.querySelectorAll('[data-dv-selected]').forEach((el) => el.removeAttribute('data-dv-selected'));
    };

    return {
      destroy() {
        if (observer) observer.disconnect();
        html.style.removeProperty('--announcement-bar-height');
      },
      onBlockSelect(block) {
        if (!bar.contains(block)) return;
        clearSelection();
        block.setAttribute('data-dv-selected', '');
        bar.classList.add('dv-announcement--editing');
      },
      onBlockDeselect() {
        clearSelection();
      },
    };
  });
})();
